export enum LocalStorageKey {
  user = 'user',
  userLocation = 'location',
  userRole = 'role',
  aPlayerStatus = 'aPlayerStatus',
  language = 'language',
  i18n = 'i18nextLng',
  discountEditor = 'discountEditor',
  discountEditorStep = 'discountEditorStep',
  favoritesAddedAt = 'favoritesAddedAt',
  statisticsCurrentCountry = 'statisticsCurrentCountry',
  cardsLayout = 'cardsLayout',
}
